import { Pipe, PipeTransform } from '@angular/core';
import { Pokemon } from './pokemon';
/*
 * Affiche la couleur correspondant au type du pokémon.
 * Prend en argument le type du pokémon.
 * Exemple d'utilisation:
 *   {{ pokemon.type | pokemonTypeColor }}
*/
@Pipe({ name: 'pokemonTypeColor' })
export class PokemonTypeColorPipe implements PipeTransform {

  transform(type: string): string {

    let color: string;

    switch (type) {
      case 'Feu':
        color = 'red lighten-1';
        break;
      case 'Eau':
        color = 'blue lighten-1';
        break;
      case 'Plante':
        color = 'green lighten-1';
        break;
      case 'Insecte':
        color = 'brown lighten-1';
        break;
      case 'Normal':
        color = 'grey lighten-3';
        break;
      case 'Vol':
        color = 'blue lighten-3';
        break;
      case 'Poison':
        color = 'deep-purple accent-1';
        break;
      case 'Fée':
        color = 'pink lighten-4';
        break;
      case 'Psy':
        color = 'deep-purple darken-1';
        break;
      case 'Electrik':
        color = 'lime accent-1';
        break;
      case 'Combat':
        color = 'deep-orange';
        break;
      case 'Acier':
        color = 'blue-grey darken-1';
        break;
      case 'Dragon':
        color = 'indigo darken-2';
        break;
      case 'Glace':
        color = 'cyan lighten-1';
        break;
      case 'Roche':
        color = 'brown';
        break;
      case 'Sol':
        color = 'amber ligten-4';
        break;
      case 'Spectre':
        color = 'purple darken-2';
        break;
      case 'Tenebres':
        color = 'grey darken-3';
        break;
      case 'Obscur':
        color = 'grey darken-2';
        break;
      case '???':
        color = 'blue-grey lighten-3';
        break;
      default:
        color = 'grey';
        break;
    }
    return 'chip ' + color;
  }
}
